// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__IBMPlexSansRegular_563506', '__IBMPlexSansRegular_Fallback_563506'","fontWeight":400},"className":"__className_563506","variable":"__variable_563506"};